import React from 'react';
import { GeckoFormField, GeckoModal } from 'ui';
import AnswerSelect from 'components/AnswerSelect';
import ConversationSnippet from '../ConversationSnippet';
import './index.scss';
import { useBulkResolveModal, useSingleResolveModal } from './data';

const ResolveModal = (props) => {
  const {
    botId,
    message,
    values,
    handleQuestionChange,
    setResponseId,
    footerBtns,
    conversationSnippetClass,
    exampleSnippetClass,
    closeModal,
    answerLinkText,
  } = props;

  return (
    <div className="Train-ResolveModal">
      <GeckoModal name="Resolve Unknown Answer" btns={footerBtns}>
        <div className="ResolveModal-ConversationSnippet row">
          <div className={conversationSnippetClass}>
            <span className="Train-ResolveModal-table-titles">
              Missed Message Conversation
            </span>
            <ConversationSnippet message={message} botId={botId} />
          </div>
          <div className={exampleSnippetClass}>
            <span className="Train-ResolveModal-table-titles">
              Example Conversation
            </span>
            <ConversationSnippet
              message={message}
              answerId={values.response_id}
              botId={botId}
            />
          </div>
        </div>
        <hr />
        {Object.entries(values)
          .filter(([key]) => {
            return key.indexOf('question|') === 0;
          })
          .map(([key, value], index) => {
            return (
              <GeckoFormField
                key={key}
                fieldType="text"
                name={key}
                label={index === 0 ? 'Add to question bank' : ''}
                aria-label={index === 0 ? '' : 'Add to question bank'}
                value={value}
                onChange={handleQuestionChange}
                error={
                  value && value.length > 255
                    ? `Training opportunity is too long - ${value.length}/255`
                    : null
                }
                showErrorAsTooltip
              />
            );
          })}
        <AnswerSelect
          botId={botId}
          value={values.response_id}
          onChange={setResponseId}
        />
        <span className="Train-ResolveModal-create-answer-text">
          Or{' '}
          <a
            className="Train-ResolveModal-create-answer-text-link"
            onClick={closeModal}
            href={answerLinkText}
          >
            create a new answer
          </a>
        </span>
      </GeckoModal>
    </div>
  );
};

export const SingleResolveModal = (props) => {
  const { botId, miss_id, message } = props;
  const singleResolveModalData = useSingleResolveModal({
    botId,
    miss_id,
    message,
  });
  return (
    <ResolveModal botId={botId} message={message} {...singleResolveModalData} />
  );
};

export const BulkResolveModal = (props) => {
  const { botId, missIds, message } = props;
  const bulkResolveModalData = useBulkResolveModal({ botId, missIds, message });
  return (
    <ResolveModal botId={botId} message={message} {...bulkResolveModalData} />
  );
};
